import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class NotificationsService {
  url = `${environment.apiUrl}`;
  authUrl = `${environment.authUrl}`;

  constructor(private http: HttpClient) {}

  public getAllNotifications(params:any): Observable<any> {
    return this.http.get(`${this.authUrl}/frontoffice/notifications`, {
        params: params,
        observe: "response",
    });
  }
  public deleteAllNotifications(): Observable<any> {
    return this.http.delete(`${this.authUrl}/frontoffice/delete/notifications/all`, {
        params: {},
        observe: "response",
    });
  }
  

}
